import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useUser } from './Context/UserContext';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import "../styles/CreateInvoice.css";
import profileImg from '../assets/logo.png';
import DashboardLayout from "../components/DashboardLayout";
const ChangePasswordNew = () => {
    const { user } = useUser();

    const userId = user?.id || sessionStorage.getItem("userId");

    const [formData, setFormData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    }; 


        // ✅ VALIDATION (your password requirements included) 
        const validate = () => {
            let newErrors = {};

            if (!formData.currentPassword.trim()) {
                newErrors.currentPassword = "Current Password is required";
            }

            const passwordRegex =
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

            if (!formData.newPassword.trim()) {
                newErrors.newPassword = "New Password is required";
            } else if (!passwordRegex.test(formData.newPassword)) {
                newErrors.newPassword =
                    "Password must be at least 8 characters and contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.";
            }

            if (!formData.confirmPassword.trim()) {
                newErrors.confirmPassword = "Confirm Password is required";
            } else if (
                formData.newPassword !== formData.confirmPassword
            ) {
                newErrors.confirmPassword =
                    "New Password and Confirm Password do not match";
            }

            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        };

        // ✅ HANDLE SUBMIT (FIXED - outside validate)
        const handleSubmit = async (e) => {
            e.preventDefault();

            setSuccessMessage("");
            setErrorMessage("");

            if (!validate()) return;

            try {
                await axios.post(
                    "/api/userregistration/change-password",
                    {
                        userId,
                        currentPassword: formData.currentPassword,
                        newPassword: formData.newPassword,
                    }
                );

                setSuccessMessage("Password changed successfully."); 

                setFormData({
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                });
            } catch (error) {
                setErrorMessage(
                    error.response?.data?.message ||
                    "Failed to change password."
                );
            }
        };
    return (
        <DashboardLayout>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "80vh",
                    backgroundColor: "#f5f7fa",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "500px",
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                    }}
                >
                    <h2
                        style={{
                            textAlign: "center",
                            marginBottom: "25px",
                            color: "#0d6efd",
                            fontWeight: "600",
                        }}
                    >
                        Change Password
                    </h2>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">
                                Current Password
                            </label>
                            <input
                                type="password"
                                name="currentPassword"
                                value={formData.currentPassword}
                                onChange={handleChange}
                                className="form-control"
                            />
                            {errors.currentPassword && (
                                <small className="text-danger">
                                    {errors.currentPassword}
                                </small>
                            )}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                New Password
                            </label>
                            <input
                                type="password"
                                name="newPassword"
                                value={formData.newPassword}
                                onChange={handleChange}
                                className="form-control"
                            />
                            {/* Password Requirements */}

                            <div className="mt-2">
                                <small
                                    style={{
                                        color: /[A-Z]/.test(formData.newPassword)
                                            ? "green"
                                            : "red",
                                    }}
                                >
                                    ✓ One uppercase letter
                                </small>
                                <br />

                                <small
                                    style={{
                                        color: /[a-z]/.test(formData.newPassword)
                                            ? "green"
                                            : "red",
                                    }}
                                >
                                    ✓ One lowercase letter
                                </small>
                                <br />

                                <small
                                    style={{
                                        color: /\d/.test(formData.newPassword)
                                            ? "green"
                                            : "red",
                                    }}
                                >
                                    ✓ One number
                                </small>
                                <br />

                                <small
                                    style={{
                                        color: /[@$!%*?&]/.test(formData.newPassword)
                                            ? "green"
                                            : "red",
                                    }}
                                >
                                    ✓ One special character
                                </small>
                                <br />

                                <small
                                    style={{
                                        color:
                                            formData.newPassword.length >= 8
                                                ? "green"
                                                : "red",
                                    }}
                                >
                                    ✓ Minimum 8 characters
                                </small>
                            </div>

                            {errors.newPassword && (
                                <small className="text-danger">
                                    {errors.newPassword}
                                </small>
                            )}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                Confirm Password
                            </label>
                            <input
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                className="form-control"
                            />
                            {errors.confirmPassword && (
                                <small className="text-danger">
                                    {errors.confirmPassword}
                                </small>
                            )}
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary w-100"
                            style={{
                                padding: "10px",
                                fontWeight: "600",
                            }}
                        >
                            Change Password
                        </button>

                        {successMessage && (
                            <div
                                className="alert alert-success mt-3"
                            >
                                {successMessage}
                            </div>
                        )}

                        {errorMessage && (
                            <div
                                className="alert alert-danger mt-3"
                            >
                                {errorMessage}
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </DashboardLayout>
     );
};

export default ChangePasswordNew;